/**
 * @Author: 左建
 * @Date: 2022/8/1 20:42
 * @LastEditTime: 2022/8/1 20:42
 * @Description: datePicker的一些配置项
*/
import { clearTime, formatDate, parseDate, toDate } from "element-ui/lib/utils/date-util"

function fillEndDayTime (date) {
    if (date instanceof Date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)
    }
}
export const DATE_FORMAT_BY_TYPE = Object.freeze({
    year: "yyyy",
    month: "yyyy-MM",
    date: "yyyy-MM-dd",
    week: "yyyy-WW",
    dates: "yyyy-MM-dd",
    datetime: "yyyy-MM-dd HH:mm:ss",
    datetimerange: "yyyy-MM-dd HH:mm:ss",
    daterange: "yyyy-MM-dd",
    monthrange: "yyyy-MM"
})

export const DATE_PLACEHOLDER_BY_TYPE = Object.freeze({
    datetimerange: ["开始时间", "结束时间"],
    daterange: ["开始日期", "结束日期"],
    monthrange: ["开始年月", "结束年月"]
})

function getRangePickerOptions (picker, day, type = "before", isRange, currentDateAddMinutes) {
    const ms = currentDateAddMinutes * 60 * 1000
    const currentTime = new Date().getTime()
    const calcTime = type === "after" ? toDate(currentTime - ms) : toDate(currentTime + ms)
    const currentDate = type === "after" ? toDate(currentTime - ms) : toDate(currentTime + ms)
    // 计算时间
    if (type === "after") {
        calcTime.setTime(calcTime.getTime() - 3600 * 1000 * 24 * day)
        picker.$emit("pick", isRange ? [calcTime, currentDate] : toDate(currentTime))
    } else {
        calcTime.setTime(calcTime.getTime() + 3600 * 1000 * 24 * day)
        picker.$emit("pick", isRange ? [currentDate, calcTime] : toDate(currentTime))
    }
}
// 获取表单时间选择pickerOptions
export function getPickerOptions (isRange, disabled) {
    const vm = this
    const textMap = {
        before: isRange ? "往后" : "后",
        after: isRange ? "最近" : "前"
    }
    const getText = (text) => isRange ? textMap[disabled] + text : text + textMap[disabled]
    const shortCuts = [
        {
            text: "今天",
            onClick (picker) {
                const ms = vm.currentDateAddMinutes * 60 * 1000
                const currentDate = new Date()
                const afterDate = toDate(currentDate.getTime() - ms)
                const beforeDate = toDate(currentDate.getTime() + ms)
                if (isRange) {
                    if (disabled === "after") {
                        picker.$emit("pick", [clearTime(currentDate), afterDate])
                    } else if (disabled === "before") {
                        picker.$emit("pick", [beforeDate, fillEndDayTime(currentDate)])
                    }
                } else {
                    if (disabled === "after") {
                        picker.$emit("pick", afterDate)
                    } else if (disabled === "before") {
                        picker.$emit("pick", beforeDate)
                    }
                }
            }
        },
        {
            text: isRange ? textMap[disabled] + "一天" : disabled === "before" ? "明天" : "昨天",
            onClick (picker) {
                getRangePickerOptions(picker, 1, disabled, isRange, vm.currentDateAddMinutes)
            }
        },
        {
            text: isRange ? textMap[disabled] + "两天" : disabled === "before" ? "后天" : "前天",
            onClick (picker) {
                getRangePickerOptions(picker, 2, disabled, isRange, vm.currentDateAddMinutes)
            }
        },
        {
            text: getText("三天"),
            onClick (picker) {
                getRangePickerOptions(picker, 3, disabled, isRange, vm.currentDateAddMinutes)
            }
        },
        {
            text: getText("一周"),
            onClick (picker) {
                getRangePickerOptions(picker, 7, disabled, isRange, vm.currentDateAddMinutes)
            }
        },
        {
            text: getText("一个月"),
            onClick (picker) {
                getRangePickerOptions(picker, 30, disabled, isRange, vm.currentDateAddMinutes)
            }
        },
        {
            text: getText("两个月"),
            onClick (picker) {
                getRangePickerOptions(picker, 60, disabled, isRange, vm.currentDateAddMinutes)
            }
        },
        {
            text: getText("三个月"),
            onClick (picker) {
                getRangePickerOptions(picker, 90, disabled, isRange, vm.currentDateAddMinutes)
            }
        },
        {
            text: getText("半年"),
            onClick (picker) {
                getRangePickerOptions(picker, 180, disabled, isRange, vm.currentDateAddMinutes)
            }
        },
        {
            text: getText("一年"),
            onClick (picker) {
                getRangePickerOptions(picker, 365, disabled, isRange, vm.currentDateAddMinutes)
            }
        }
    ]
    return {
        shortcuts: shortCuts,
        disabledDate (t) {
            if (disabled === "after") return t.getTime() > new Date().getTime()
            return t.getTime() < new Date().getTime() - 3600 * 24 * 1000
        },
        onPick ({ maxDate, minDate }) {
            if (vm.type.includes("timerange") && ["before", "after"].includes(disabled)) {
                if (disabled === "after") {
                    setTimeout(() => {
                        const currentDate = new Date()
                        if (maxDate && formatDate(currentDate) === formatDate(maxDate)) {
                            if (vm.currentDateAddMinutes) {
                                const ms = vm.currentDateAddMinutes * 60 * 1000
                                if (minDate) {
                                    const minDateTime = clearTime(this.minDate)
                                    const flag = Math.abs(currentDate.getTime() - minDateTime.getTime()) - ms < 0
                                    if (flag) {
                                        this.minDate = toDate(minDateTime.getTime() - ms)
                                    } else {
                                        if (formatDate(currentDate) === formatDate(minDate)) {
                                            if (Array.isArray(vm.defaultTime) && vm.defaultTime[0] !== "00:00:00") {
                                                this.minDate = minDateTime
                                            }
                                        }
                                    }
                                }
                                this.maxDate = toDate(currentDate.getTime() - ms)
                            } else {
                                if (maxDate) {
                                    this.maxDate = currentDate
                                }
                            }
                        }
                    }, 50)
                } else {
                    setTimeout(() => {
                        const currentDate = new Date()
                        if (minDate && formatDate(currentDate) === formatDate(minDate)) {
                            if (vm.currentDateAddMinutes) {
                                const ms = vm.currentDateAddMinutes * 60 * 1000
                                if (maxDate) {
                                    const maxDateTime = fillEndDayTime(this.maxDate)
                                    const flag = Math.abs(currentDate.getTime() - maxDateTime.getTime()) - ms < 0
                                    if (flag) {
                                        this.maxDate = toDate(maxDateTime.getTime() + ms)
                                    } else {
                                        if (formatDate(currentDate) === formatDate(maxDate)) {
                                            this.maxDate = fillEndDayTime(currentDate)
                                        }
                                    }
                                }
                                this.minDate = toDate(currentDate.getTime() + ms)
                            } else {
                                if (minDate) {
                                    this.minDate = currentDate
                                }
                                if (maxDate && formatDate(currentDate) === formatDate(maxDate)) {
                                    this.maxDate = fillEndDayTime(currentDate)
                                }
                            }
                        }
                    }, 50)
                }
            }
        }
    }
}

// 获取禁用的时间段
export function getDisabledTime (disabled, data) {
    const fillZero = (val) => String(val).padStart(2, "0")
    const format = "HH:mm:ss"
    const str = `${fillZero(data.getHours())}:${fillZero(data.getMinutes())}:${fillZero(data.getSeconds())}`
    if (disabled === "after") {
        return [[parseDate("00:00:00", format), parseDate(str, format)]]
    } else {
        return [[parseDate(str, format), parseDate("23:59:59", format)]]
    }
}

export function setDisabledTimeSelect (currentDate, disabled) {
    const picker = this
    const format = "HH:mm:ss"
    if (disabled === "after") {
        picker.$refs.maxTimePicker.selectableRange = [
            [
                parseDate("00:00:00", format),
                parseDate(formatDate(currentDate, format), format)
            ]
        ]
        picker.$refs.minTimePicker.selectableRange = [
            [
                parseDate("00:00:00", format),
                parseDate(formatDate(currentDate, format), format)
            ]
        ]
    } else if (disabled === "before") {
        picker.$refs.minTimePicker.selectableRange = [
            [
                parseDate(formatDate(currentDate, format), format),
                parseDate("23:59:59", format)
            ]
        ]
        picker.$refs.maxTimePicker.selectableRange = [
            [
                parseDate(formatDate(currentDate, format), format),
                parseDate("23:59:59", format)
            ]
        ]
    }
}
